export default function (other) {
  other = other || {}
  return {
    firstName: other.firstName,
    lastName: other.lastName,
    email: other.email,
    phone: other.phone,
    username: other.username,
    orgIds: other.orgIds,
    roleId: other.roleId,
    businessUnitIds: other.businessUnitIds,
    search: other.search,
    pagination: other.pagination,
    sort: other.sort,
  }
}
